import About from "../Components/About"
import Contact from "../Components/Contact"
import Footer from "../Components/Footer"
import Home from "../Components/Home"
import Testimonial from "../Components/Testimonial"
import Work from "../Components/Work"

export default function HomeScreen() {
    return(
     <div>
      <Home/>
      <About />
      <Work />
      <Testimonial />
      <Contact />
      <Footer />
      </div>
    )
}